<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12 card">
        <div class="container-fluid card-body">
          <div class="d-flex justify-content-between mb-2">
          <span><router-link :to="{ path: '/testresultreports'}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-arrow-left"></i> Back</router-link></span>
          <span><router-link :to="{ path: '/printtestreport',  query: { id: this.$route.query.id }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-printer"></i> Print</router-link></span>
         <span v-show="insuredtest != 4"><button type="button" class="btn-sm btn btn-primary" v-b-modal.new-service><i class="mdi mdi-service"></i> Service</button></span>
  
          </div>
              <div class="row d-flex justify-content-between">
                <div class="col-5">
                    <img class="img-rounded" src="@/assets/images/sick.png" height="50px" /><br>
                    <table class="table" density="compact" style="color:black">
                    <tr><td>Full Name: </td><td class="h5"> {{ patientData.name }}</td></tr>
                    <tr><td>Gender: </td><td class="h6"> {{ patientData.gender }} </td> </tr>
                    <tr><td> Telephone: </td><td class="h6"> 0{{ patientData.telephone }} </td></tr>
                    <tr><td> Age: </td><td class="h6"> {{ getAge(patientData.date_of_birth) }}  </td></tr>
                    <tr><td> Address: </td><td class="h6"> {{ patientData.address }} </td></tr>
                  </table>
                </div>
                <div class="col-4">
                  <span v-if="userData.logo!=0"><img :src="getLogo(userData.logo)" height="90px"/></span>
                    <span v-else><img src="@/assets/images/logo.png" height="50"/></span>
                    
                    <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
                    <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
                    <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br>
                    <span style="color:black;font-size:13px">Email : {{ userData.email }}</span><br>
                    <span style="color:black;font-size:13px">Website : {{ userData.website }}</span><br>
                    <span v-if="userData.slogan" style="color:black;font-size:13px;font-style:italic">Slogan: {{ userData.slogan }}</span><br>
                </div>
              </div>
              <h6 class="mt-2 text-center">Date : {{ visit_date }}</h6>
              <h4 class="mt-2 text-center text-decoration-underline">Laboratory Results</h4>

              <div class="my-2">
                <table class="table table-sm mt-2" style="color: black;" density="compact">
                  <thead><tr><th>Test</th><th>Sample</th><th>Results</th></tr></thead>
                  <tbody>
                    <tr v-for="item in patientTest" :key="item.id">
                      <td>
            
                          <template v-if ="isPaymentTypeValid">
                            {{ item.test.name }} <br><b class="small" v-if="userData.settings.show_detailed_lab_results">{{ commas(item.test.serviceprice) }}</b>
                
                          </template>
                          <template v-else>
                            {{ item.insurancetest.name }} <br><b class="small">{{ ("Insured") }}</b>
                
                          </template> 

                      </td>
                      <td><span v-html="item.sample.name"></span></td>
                      <td><span v-html="item.result"></span></td>
                    </tr> 
                  </tbody>
                </table>
              </div> 
                            
            </div>
      </div>
    </div>
    <!-- <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer>
      <form @submit.prevent="AddPatientService">
        <div class="form-group mb-2">
          <label>Service Category</label> <small class="text-danger">*</small>
          <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Name</label> <small class="text-danger">*</small>
          <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Service Cost</label> <small class="text-danger">*</small>
          <input v-model="service_price" readonly required type="number" class="form-control" />
        </div>
        <br><span class="text-danger">{{ saveerror }}</span>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
        <b-button type="submit" :disabled="savebtn <= false" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    </b-modal> -->
    <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer >
    <!-- <template v-if="isPaymentTypeValid"> -->
    <!-- Default form for users without insurance -->
    <form @submit.prevent="AddPatientService">
      <div class="form-group mb-2">
        <label>Service Category  </label> <small class="text-danger">*</small>
        <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
      </div>
      <div class="form-group mb-2">
        <label>Service Name</label> <small class="text-danger">*</small>
        <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
      </div>
      <div class="form-group mb-2">
        <label>Service Cost</label> <small class="text-danger">*</small>
        <input v-model="service_price" readonly required type="number" class="form-control" />
      </div>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')">Close</b-button>
        <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
    <!-- <template v-if="isPaymentTypeValid"> -->
      <!-- <template v-else> -->
    <!-- Form for users with insurance -->
    <!-- <form @submit.prevent="AddPatientService"> 
      <div class="form-group mb-2">
        <label>Service Category ins</label> <small class="text-danger">*</small>
        <multiselect v-model="insurance_category" @input="FilterInsuranceService" :options="servicecategories" label="name"></multiselect>
      </div>
      <div class="form-group mb-2">
        <label>Service Name</label> <small class="text-danger">*</small>
        <multiselect v-model="insurance_service" @input="FilterInsurancePrice" label="name" :options="insurancesservices"></multiselect>
      </div>
      <div class="row justify-content-center">
        <div class="form-group mb-2">
          <label>Service Cost</label> <small class="text-danger">*</small>
          <input v-model="service_price" readonly required type="number" class="form-control" />
        </div>
      </div>
      <div class="form-group d-flex justify-content-end">
        <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')">Close</b-button>
        <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
      </div>
    </form>
   </template>  -->
</b-modal>


  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { serviceCategoryMethods,serviceCategoryComputed, insurancesMethods, insurancesComputed , packagesComputed,packagesMethods} from "@/state/helpers";


export default {
  page: {
    title: "Patient Lab Report",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,Multiselect,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Lab Report",
      items: [{text: "Dashboard",to: "/",},{text: "Patient Lab Report",active: true,},],
      patientTest:[],
      patientData:[],
      patients:[],
      service_category:[],
      patientid:'',
      visitid:'',
      visits:[],
      service_name:[],
      service_price:'',
      savebtn:true,
      saveerror:'',
      savebtn1:true,
      saveerror1:'',
      serviceid:'',
      servicename:'',
      newservices:[],
      visit_date:new Date().toLocaleDateString('fr-CA'),
      payment_types:'',
      insurance_service_name:[],
      insurances:[],
      packages:[],
      insurancespackagescost:[],
      insurancescategory:[],
      insurancesservices:[],
      insurance_company:'',
      insurance_package:'',
      insurance_category:'',
      insurance_service:'',
      insurance_cost:'',
      insurancetest:[],
      visit:[],
      insurance_price:'',
      patientDatavisit:[],
      name:'',
      insure:'',
      test:[],
      insuredtest:'',
      
     
    };
  },
  created() {
    
    this.showlabresults();
    this.showpatientinfo();
    this.showpatientlabpayinfo();
    // this.fetchInfo();
    this.fetchServiceCategory();
    this.fetchInsurances();
    this.fetchInsurancePackages();

    // this.FilterInsuranceService();
   
   
  },
  computed: {
      ...serviceCategoryComputed,
      ...insurancesComputed,
      ...packagesComputed,
      isPaymentTypeValid() {
          // return this.notest != '';
          return this.insuredtest!= 4;
          
         },

      },
  methods: {
    ...serviceCategoryMethods,
    ...insurancesMethods,
    ...packagesMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getLogo(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },


     async showpatientinfo(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabinfo";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientData=response.data.patient;
        }
      })
    },
    // getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;
    return `${years} yrs`;

  } else {
    return `${months} months old`;
  }
},
    async FilterCategory(){
      let url = `/servicebycategory/${this.service_category.id}`;
        await axios.get(url).then((response) => {
        this.newservices = response.data.services;
      });
    },
    
    async fetchInfo() {
  
    let url = `/visitinfo/${this.id}`;
    const response = await axios.get(url);
    // this.patientid = response.data.visits[0].patientData.patient_id;
    this.patientid = response.data.visits[0].patient.patient_id;
    this.visitid = response.data.visits[0].visit_id;
    if (response.data.visits[0].service_name?.name) {
      this.service = response.data.visits[0].service_name.name;
    } else if (response.data.visits[0].insurance_service_name?.name) {
      this.service = response.data.visits[0].insurance_service_name.name;
    }
    if ( response.data.visits[0].insurance_service_name ) {
      // this.insured = response.data.visits[0].insurance_service_name.insurance_price;
    this.insurance_company = response.data.visits[0].insurance_service_name.insurance_id;
    this.insurance_package = response.data.visits[0].insurance_service_name.package_id;
    this.insurance_category = response.data.visits[0].insurance_service_name.category;
          }
    // this.insured = response.data.visits[0].insurance_service_name.insurance_price;
    // this.insurance_company = response.data.visits[0].insurance_service_name.insurance_id;
    // this.insurance_package = response.data.visits[0].insurance_service_name.package_id;
    // this.insurance_category = response.data.visits[0].insurance_service_name.category;
    if (response.data.visits[0].service_name?.id) {
      this.service_id = response.data.visits[0].service_name.id;
    } else if (response.data.visits[0].insurance_service_name?.id) {
      this.service_id = response.data.visits[0].insurance_service_name.id;
    }  
    this.visit_date = response.data.visits[0].addedon;
    // alert('this.visit_date');
   
    
    
 
},


      async showpatientlabpayinfo() {
  
    this.visit_id = this.$route.query.id;
    let formData = new FormData();
    formData.append("visit_id", this.visit_id);
    let url = "/findpatientlabpayinfo";
    const response = await axios.post(url, formData);
    if (response.status == 200) {
      
      this.patientDatavisit = response.data.visit;
      if (this.patientDatavisit) {
        this.id = this.patientDatavisit.id; // Assign the visit's id to the id variable
        await this.fetchInfo(); // Call fetchInfo after obtaining the id
      }
     
    }
 
},

    async AddPatientService() { 
        this.savebtn=false;
        this.saveerror="Saving Patient Visit";
        let formData = new FormData();
        formData.append("patient_id", this.patientData.patient_id);
        formData.append("visit_id", this.$route.query.id);
        // formData.append("service_category", this.service_category.id ?? this.cat_id);
        // formData.append("service_name", this.service_name.id);
        formData.append("service_price", this.service_price);
        formData.append("service_category", this.service_category.id ? this.service_category.id : 0);
        formData.append("service_name", this.service_name.id ? this.service_name.id : 0);
        formData.append("insurance_company", this.insurance_company? this.insurance_company: 0);
        formData.append("insurance_category", this.insurance_category.id ? this.insurance_category.id : 0);
        formData.append("insurance_package", this.insurance_package ? this.insurance_package : 0);
        formData.append("insurance_service", this.insurance_service.id ? this.insurance_service.id : 0);

      
        let url = "/addpatientvisit";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-service');
            this.service_category="";
            this.service_name="";
            this.service_price="";
            // this.insurance_company="";
            this.insurance_category="";
            // this.insurance_package="";
            this.insurance_service="";
            this.$toast.success("New Patient Service Added");
            this.savebtn=true;
            this.saveerror="";
        }
        });
    },
   
    async FilterServicePrice(){
      let url = `/serviceprice/${this.service_name.id}`;
      await axios.get(url).then((response) => {
        this.service_price = response.data.price;
      });
    },
   
    async showlabresults(){
      this.visit_id=this.$route.query.id;
      let url = `/labpatientprofile/${this.visit_id}`;
      await axios.get(url).then((response) => {
        this.patientTest = response.data.results;
        this.insure = response.data.results[0].test.name;
        this.insuredtest = response.data.results[0].patientvisit.payment_type;
       
           });
    },
    async FilterInsurancePackage() {

let url = `/packagebyinsurance/${this.insurance_company.id}`;

  await axios.get(url).then((response) => {

    this.insurancespackagescost = response.data.insurancespackagescost;
  })

},

async FilterInsuranceCategory() {

let url = `/categorybyinsurance/${this.insurance_package}`;

  await axios.get(url).then((response) => {

    this.insurancescategory = response.data.insurancescategory;
})

},

async FilterInsuranceService( ) {

//  let url = `/servicebyinsurance/${this.insurance_category.id},${this.insurance_package.id}`;
let url = `/servicebyinsurance/${this.insurance_category.id},${this.insurance_package}`;

  await axios.get(url).then((response) => {

    this.insurancesservices = response.data.insurancesservices;
})

},

async FilterInsurancePrice(){
          let url = `/insuranceprice/${this.insurance_service.id}`;
          await axios.get(url).then((response) => {
            this.service_price = response.data.insuranceprice;
            
            });

            
        },
  },

};
</script>